import React from 'react';
import './Header.css';

export default function Header(props) {
	return <div className="header">{props.breadcrumb}</div>;
}
